import { render, staticRenderFns } from "./IbxWarningModal.vue?vue&type=template&id=5f46f00b&scoped=true"
import script from "./IbxWarningModal.vue?vue&type=script&lang=js"
export * from "./IbxWarningModal.vue?vue&type=script&lang=js"
import style0 from "./IbxWarningModal.vue?vue&type=style&index=0&id=5f46f00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46f00b",
  null
  
)

export default component.exports